import { useTheme } from "../../context/ThemeContext";

export default function BannerPerformanceWidget({
  banners = [],
}) {

  const { isDark } = useTheme();

  return (
    <div
      className={`
        rounded-3xl
        border
        p-6
        ${
          isDark
            ? "bg-white/5 border-white/10"
            : "bg-white border-gray-200"
        }
      `}
    >
      <h2 className="text-xl font-semibold mb-6">
        Banner Performance
      </h2>

      <div className="space-y-5">

        {banners.map((banner) => (

          <div
            key={banner.id}
            className={`
              p-4
              rounded-2xl
              ${
                isDark
                  ? "bg-white/5"
                  : "bg-gray-50"
              }
            `}
          >
            <div className="flex justify-between">

              <h3 className="font-medium">
                {banner.title}
              </h3>

              <span
                className="
                  text-blue-700
                  font-semibold
                "
              >
                {banner.ctr}%
              </span>

            </div>

            <div
              className="
                mt-3
                flex
                gap-6
                text-sm
              "
            >
              <span>
                Impressions:
                {" "}
                {banner.impressions}
              </span>

              <span>
                Clicks:
                {" "}
                {banner.clicks}
              </span>
            </div>

          </div>

        ))}

      </div>
    </div>
  );
}